import type { Session } from '@bear-auth/core';
import { createSlice, type PayloadAction, type SliceCaseReducers } from '@reduxjs/toolkit';

import type { AppState } from '@/types';

import type { AuthUser } from '../../schemas/oauth';

// Define the initial state using that type
const initialState: Session<AuthUser> = {
    status: 'retrieving',
    data: null,
};

export const authSlice = createSlice<Session<AuthUser>, SliceCaseReducers<Session<AuthUser>>>({
    name: 'auth',
    initialState,
    reducers: {
        setSession: (state, action: PayloadAction<Session<AuthUser>>) => {
            Object.assign(state, action.payload);
        },
        updateAuthInfo: (state, action: PayloadAction<AuthUser>) => {
            Object.assign(state.data?.authInfo ?? {}, action.payload);
        },
    },
});

export const { setSession, updateAuthInfo } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectAuth = (state: AppState) => state.auth as Session<AuthUser>;

export const authReducer = authSlice.reducer;
